export default __webpack_public_path__ + "static/media/particle.998d493b.png";